import { render } from "./transcripts.vue?vue&type=template&id=a4b1789e&ts=true"
import script from "./transcripts.vue?vue&type=script&lang=ts"
export * from "./transcripts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__